import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { DateTime } from "components/common/Date";
import { StockMovementTypeLabel } from "../constants/stock-movement.constants";
import OverviewTab from "./OverviewTab";
import { useStockMovementOverview } from "./StockMovementOverviewContext";

const Section = () => {
  const { stockMovement: record } = useStockMovementOverview();

  if (!record) {
    return (
      <Row>
        <Col lg={12}>
          <p className="text-muted mb-0">
            This stock movement could not be loaded.
          </p>
          <Link
            to="/inventory-management/stock-movements"
            className="btn btn-light btn-sm mt-2"
          >
            Back to list
          </Link>
        </Col>
      </Row>
    );
  }

  const displayTitle = `Movement #${record.id}`;
  const typeLabel = record.movementType
    ? StockMovementTypeLabel[record.movementType]
    : "—";
  const when = record.createdAt ?? record.created_at;

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card className="mt-n4 mx-n4">
            <div className="bg-light-subtle">
              <CardBody className="pb-0 px-4">
                <Row className="mb-3">
                  <div className="col-md">
                    <div>
                      <h4 className="fw-bold">{displayTitle}</h4>
                      <p className="text-muted mb-1">
                        <span className="fw-medium">{typeLabel}</span>
                      </p>
                      {when ? (
                        <div className="hstack gap-3 flex-wrap">
                          <div>
                            Created:{" "}
                            <span className="fw-medium">
                              <DateTime date={when} />
                            </span>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Row>
              </CardBody>
            </div>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <OverviewTab />
        </Col>
      </Row>
      <Link
        to="/inventory-management/stock-movements"
        className="btn btn-link ps-0 mt-3"
      >
        ← Back to stock movements
      </Link>
    </React.Fragment>
  );
};

export default Section;
